import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import store from "./store";

import "normalize.css/normalize.css";
import "./styles/index.scss";

// if (process.env.NODE_ENV === "development") {
const { mockXHR } = require("../mock");
mockXHR();
// }

Vue.config.productionTip = false;

new Vue({
  router,
  store,
  render: (h) => h(App),
}).$mount("#app");
